import React from "react";
import { useSearchParams } from "react-router-dom";
import { Header, Tab } from "semantic-ui-react"
import DatabaseStatus from "./components/databaseStatus";
import TaskManagement from "./components/tasksManagement";
import QualityMetrix from "./components/quality";
import PerformanceManagement from "./components/performance";
import ProductivityMetrix from "./components/productivity/productivity";
import KpisChart from "./components/kpisChart";
import AuthService from "../../../service/auth";
import { userIDsWithKPIsChartReadPermissions } from "./components/kpisChart/constants";
import { getPaneCfg } from "../../../utils/general";
import QaReviews from "./components/qaReviews";

function GloalKPIs() {
    const [searchParams, setSearchParams] = useSearchParams();
    const panes = [
        { key: "database-status", ...getPaneCfg("Database Status", <DatabaseStatus />) },
        { key: "tasks-management", ...getPaneCfg("Tasks Management", <TaskManagement />) },
        { key: "performance", ...getPaneCfg("Performance (DEPRECATED)", <PerformanceManagement />) },
        { key: "quality", ...getPaneCfg("Quality", <QualityMetrix />) },
        { key: "qa-reviews", ...getPaneCfg("QA Reviews Distribution", <QaReviews />) },
        { key: "productivity", ...getPaneCfg("Productivity", <ProductivityMetrix />) },

    ]

    const currentUserId = AuthService.getUserId();

    if (userIDsWithKPIsChartReadPermissions.includes(currentUserId)) {
        panes.push(
            { key: "kpis-chart", ...getPaneCfg("KPIs Chart", <KpisChart />) }
        )
    }

    const activeIndex = Math.max(0, panes.findIndex(pane => pane.key === searchParams.get("tab")));

    function handleTabChange(_event, { activeIndex }) {
        const pane = panes[activeIndex];
        if (!pane) {
            return;
        }

        const nextSearchParams = new URLSearchParams(searchParams);
        nextSearchParams.set("tab", pane.key);
        setSearchParams(nextSearchParams, { replace: true });
    }

    return <>
        <Header as="h2" textAlign='center'>KPIs</Header>
        <Tab panes={panes} activeIndex={activeIndex} onTabChange={handleTabChange} />
    </>
}

export default GloalKPIs
